export enum QuestionReplyType {
	User = 'user',
	LegacyAi = 'legacy_ai',
	Ai = 'ai',
}
